import { observer } from 'mobx-react-lite';

import { userStore } from '@/stores/user.store';

import { SettingsSection } from '../settings-section';

import { SavedCredentialsGroup } from './settings-browser-credentials';

export const BrowserSettings = observer(function BrowserSettings() {
  if (!userStore.isInternalUser) return null;

  return (
    <SettingsSection.Root>
      <SettingsSection.Header>
        <SettingsSection.Title>Browser</SettingsSection.Title>
      </SettingsSection.Header>
      <SavedCredentialsGroup />
    </SettingsSection.Root>
  );
});
